<template>
  <div>
    <div class="goodsManageSet">
      <div class="banner">
        <img src="../../../assets/images/banner1.png" alt="" />
      </div>
      <div class="breadcrumb flex-rowc">
        <div class="breadcrumb_item">辅助功能&内容管理</div>
        <div class="breadcrumb_item_arrow"></div>
        <div class="breadcrumb_item">知识付费内容管理</div>
      </div>

      <div class="main_content">
        <div class="tit">知识付费内容信息设置</div>

        <div class="block">
          <h1><span class="mark">*</span>内容所属系列</h1>
          <div class="input_box flex-between" @click="handleShowpopup(1)">
            <van-field
              v-model="typestr"
              placeholder="请选择内容所属系列"
              readonly
            />
            <i class="iconfont icon-bottom"></i>
          </div>
        </div>
        <div class="block">
          <h1><span class="mark">*</span>内容标题</h1>
          <div class="input_box">
            <van-field
              v-model="formData.topic"
              placeholder="输入内容标题"
              @focus="inputFocus"
              @blur="inputBlur"
            />
          </div>
        </div>
        <div class="block">
          <h1><span class="mark">*</span>内容封面（缩略图）</h1>
          <p class="red">JPG或者PNG格式，尺寸比例宽度500像素，高度不限制</p>
          <div class="img_box">
            <van-uploader
              v-model="fileList"
              @click-upload="clickUpload(1)"
              @delete="deleteImg(1)"
              :before-read="beforeRead"
              :after-read="afterRead"
              :max-count="1"
            />
          </div>
        </div>
        <div class="block">
          <h1><span class="mark">*</span>属性</h1>
          <div class="radio_box">
            <van-radio-group direction="horizontal" v-model="formData.attrval">
              <template v-for="(item, index) in konwledgeAttr">
                <van-radio :key="index" :name="item.attrid">{{
                  item.attrname
                }}</van-radio>
              </template>
            </van-radio-group>
          </div>
        </div>
        <div class="block">
          <h1><span class="mark">*</span>内容收费价格</h1>
          <div class="input_box">
            <van-field
              v-model="formData.price"
              placeholder="输入内容收费价格"
              @focus="inputFocus"
              @blur="inputBlur"
            />
          </div>
        </div>
        <div class="block">
          <h1>是否启用</h1>
          <div class="radio_box">
            <van-radio-group direction="horizontal" v-model="formData.isuse">
              <van-radio name="启用">启用</van-radio>
              <van-radio name="停用">停用</van-radio>
            </van-radio-group>
          </div>
        </div>
      </div>

      <div class="primary-button" @click="query">保存确认</div>

      <div class="primary-button return" @click="handleReturn">
        <i class="iconfont icon-yuyinjiantou"></i>返回
      </div>
    </div>

    <van-popup v-model="isShow" round position="bottom" class="brandPopup">
      <div class="block" v-if="isShowType == 1">
        <van-picker
          title="请选择内容所属系列"
          show-toolbar
          :columns="konwledgeType"
          @confirm="onConfirm"
          value-key="typename"
          @cancel="isShow = false"
        />
      </div>
    </van-popup>
  </div>
</template>

<script>
import {
  encryptstringview,
  getKonwledgeType,
  uploadImage,
} from "../../../api/api";
import {
  addKonwledge,
  editKonwledge,
  getKonwledgeDetail,
  getKonwledgeAttr,
} from "../../../api/knowledge";
export default {
  name: "kBaseinfo",
  data() {
    return {
      loading: false,
      dialogImageUrl: "",
      dialogVisible: false,
      isShow: false,
      isShowType: 1,
      konwledgeType: [],
      konwledgeAttr: [],
      fileList: [],
      detail: "",
      formData: {
        id: "",
        typeid: "",
        qyguid: "",
        topic: "",
        cover: "",
        attrval: "",
        price: "",
        isuse: "是",
        creater: "",
      },
      typestr: "",
      creenIndex: "",
    };
  },
  created() {
    let { routerList, OPENID, USERINFO } = this.$store.state;
    let { name } = this.$route;
    if (USERINFO.qy) {
      this.formData.qyguid = USERINFO.qy.qyguid;
      this.formData.creater = USERINFO.truename;
    } else {
      this.formData.qyguid = 0;
    }
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.formData.id = id;
        if (id) {
          this.getDetail();
        } else {
          this.getKonwledgeAttr();
          this.getKonwledgeType();
        }
      } else {
        this.$router.back();
      }
    },

    // 获得焦点
    inputFocus(e) {
      this.scrollTop = "-" + (e.srcElement.getBoundingClientRect().top - 200);
      this.isShowStyle = true;
    },
    // 失去焦点
    inputBlur() {
      this.isShowStyle = false;
    },

    // 图片上传
    clickUpload(type) {
      this.isType = type;
    },
    // 删除图片
    deleteImg(isType) {
      if (isType == 1) {
        this.formData.cover = "";
      }
    },
    // 图片上传之前处理
    beforeRead(file) {
      const imgformat = /image\/(png|jpg|jpeg)$/;
      if (!imgformat.test(file.type)) {
        this.$toast.fail("请上传 jpg/png 格式图片");
        return false;
      }
      return true;
    },
    // 检测图片的宽高
    checkWidthAndHeight(file) {
      return new Promise((resolve, reject) => {
        let { isType } = this;
        let img = new Image();
        img.src = URL.createObjectURL(file);
        img.onload = function () {
          let width = img.width;
          var height = img.height;
          console.log("当前图片的宽高:" + width, height);
          if (isType == 1) {
            if (width == 500 && height == 500) {
              reject(true);
            } else {
              resolve(false);
            }
          }
        };
      });
    },
    // 图片上传后处理
    afterRead(e) {
      let { isType } = this;
      var formData = new FormData();
      formData.append("imgfile", e.file);
      const Toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
        duration: 0,
      });
      uploadImage(formData).then((res) => {
        if (res.result) {
          if (isType == 1) {
            this.formData.cover = res.url;
          }
          Toast.clear();
        } else {
          this.$toast.fail(res.message || "服务器报错，请稍后～");
          Toast.clear();
        }
      });
    },
    // 显示弹窗
    handleShowpopup(type) {
      this.isShowType = type;
      this.isShow = true;
    },
    onConfirm(e) {
      let { isShowType } = this;
      if (isShowType == 1) {
        this.formData.typeid = e.id;
        this.typestr = e.typename;
      }
      this.isShow = false;
    },

    getDetail() {
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      this.loading = true;
      getKonwledgeDetail({ id: this.formData.id }).then((res) => {
        this.formData.typeid = res.typeid;
        this.typestr = res.typeidstr;
        this.formData.topic = res.topic ? res.topic : "";
        this.formData.cover = res.cover ? res.cover : "";
        if (res.cover != "") {
          this.fileList.push({ url: res.cover });
        }
        this.formData.attrval = res.attrval ? res.attrval : "";
        this.formData.price = res.price ? res.price : "";
        this.formData.isuse = res.isuse ? res.isuse : "";
        if (res.typeid) {
          this.getKonwledgeType();
        }
        if (res.attrval) {
          this.getKonwledgeAttr();
        }

        this.loading = false;
        Toast.clear();
      });
    },

    // 知识付费类型
    getKonwledgeType() {
      let params = {
        keyword: "",
        qyguid: this.formData.qyguid,
      };
      getKonwledgeType(params).then((res) => {
        let filter = res.list.filter((v) => v.isuse == "是");
        this.konwledgeType = filter;
      });
    },

    // 知识付费属性
    getKonwledgeAttr() {
      getKonwledgeAttr().then((res) => {
        this.konwledgeAttr = res;
      });
    },

    query() {
      let { formData } = this;
      if (formData.typeid == "") {
        this.$message.warning("请选择内容所属系列");
        return;
      }
      if (formData.topic == "") {
        this.$message.warning("请输入内容标题");
        return;
      }
      if (formData.cover == "") {
        this.$message.warning("请上传内容封面");
        return;
      }
      if (formData.attrval == "") {
        this.$message.warning("请选择属性");
        return;
      }
      if (formData.price == "") {
        this.$message.warning("请输入内容收费价格");
        return;
      }
      const Toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      if (formData.id) {
        editKonwledge(formData).then((res) => {
          let data = res;
          if (data.result) {
            setTimeout(() => {
              Toast.clear();
              this.$toast.success(data.message);
            }, 500);
            // setTimeout(() => {
            //   history.back();
            // }, 1500);
          } else {
            this.$toast.fail(data.message || "服务器报错，请稍后～");
          }
        });
      } else {
        addKonwledge(formData).then((res) => {
          let data = res;
          if (data.result) {
            // setTimeout(() => {
            //   Toast.clear();
            //   this.$toast.success(data.message);
            // }, 2000);
            setTimeout(() => {
              Toast.clear();
              history.back();
            }, 500);
          } else {
            this.$toast.fail(data.message || "服务器报错，请稍后～");
          }
        });
      }
    },

    handleReturn() {
      history.back();
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  padding-bottom: 420px;
  .breadcrumb {
    padding-bottom: 60px;
  }
  .main_content {
    .tit {
      text-align: center;
      font-size: 32px;
      font-weight: bold;
      margin-bottom: 50px;
    }
    .block {
      margin-bottom: 80px;
      h1 {
        text-align: center;
        font-weight: 400;
        margin-bottom: 20px;
        font-size: 30px;
      }
      .item {
        margin-bottom: 50px;
      }
      .input_box,
      .select_box {
        margin-bottom: 30px;
      }
      p {
        font-size: 22px;
        text-align: center;
        &.red {
          color: #ff0012;
        }
      }
    }
    .img_box {
      margin: auto;
      margin-top: 40px;
      text-align: center;
    }
  }
}
</style>